<div class="sperm_retrieval_techniques ovulation_indeuction header_top mb-5">
  <section class="ovulation_induction_banner">
    <div class="container">
      <div class="banner_content">
        <h6>Sperm Retrieval Techniques</h6>
        <h5>Advanced Male Fertility Solutions in Kannur</h5>
        <!-- <b>Advanced Male Fertility Solutions in Kannur</b> -->
        <p>
          For men with low sperm count or absence of sperm in semen
          (azoospermia), advanced sperm retrieval techniques offer the chance to
          father a biological child. At NCare IVF Kannur, Kerala, our experts
          perform safe, effective procedures like TESA, PESA, TESE, and
          Microdissection TESE to retrieve healthy sperm for use in IVF or ICSI
          treatments.
        </p>
        <p>
          Personalized care, advanced microsurgical techniques, and
          compassionate support — all under one roof.
        </p>
        <button [routerLink]="['/contact-us']">Book an Appointment</button>
      </div>
    </div>
  </section>
  <section class="how_does_work_ivf mt-5">
    <div class="container">
      <div class="row aic">
        <div class="col-lg-7 col-md-7 col-sm-12">
          <h6>Who Can Benefit from Sperm Retrieval Procedures?</h6>
          <ul>
            <li>Men with azoospermia (no sperm in ejaculate)</li>
            <li>
              Cases of obstructive azoospermia (blockage in the reproductive
              tract)
            </li>
            <li>
              Men with non-obstructive azoospermia (low or absent sperm
              production)
            </li>
            <li>Men with prior vasectomy or failed vasectomy reversal</li>
            <li>
              Couples undergoing IVF/ICSI requiring direct sperm retrieval
            </li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img
            loading="lazy"
            src="../../../assets/images/sperm_retrieval_techniques/who_can_benefit.webp"
            alt=""
          />
        </div>
      </div>
    </div>
  </section>

  <section class="freezing_section mt-5">
    <div class="container">
      <div class="wrapper">
        <h4 class="title_header tac">Testicular Sperm Aspiration (TESA)</h4>

        <div class="section">
          <h2>What is TESA?</h2>
          <ul>
            <li>
              TESA is a simple, minimally invasive procedure where sperm is
              aspirated directly from the testis using a fine needle under local
              anesthesia.
            </li>
          </ul>
        </div>

        <div class="section">
          <h2>When is TESA recommended?</h2>
          <ul>
            <li>Men with obstructive azoospermia</li>
            <li>Failed PESA attempts</li>
            <li>For sperm collection on the day of ICSI</li>
          </ul>
        </div>

        <div class="section">
          <h2>Key Benefits of TESA:</h2>
          <ul>
            <li>Quick, outpatient procedure</li>
            <li>No stitches or large incisions</li>
            <li>Safe and efficient sperm retrieval</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="embryo_freezing mt-5">
    <div class="container">
      <div class="wrapper">
        <h4 class="title_header tac">
          Percutaneous Epididymal Sperm Aspiration (PESA)
        </h4>

        <div class="section">
          <h2>What is PESA?</h2>
          <ul>
            <li>
              PESA is a non-surgical technique where sperm is collected from the
              epididymis (the tube above the testis) using a fine needle.
            </li>
          </ul>
        </div>

        <div class="section">
          <h2>Who needs PESA?</h2>
          <ul>
            <li>
              Men with obstructive azoospermia due to vasectomy or congenital
              absence of vas deferens
            </li>
          </ul>
        </div>

        <div class="section">
          <h2>Advantages of PESA:</h2>
          <ul>
            <li>Minimally invasive and painless</li>
            <li>Can be performed under local anesthesia</li>
            <li>Quick recovery with minimal discomfort</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <!-- <h5>CTA BANNER CONTENT</h5> -->
        <p>
          Overcome male infertility with advanced sperm retrieval solutions.
        </p>
        <button [routerLink]="['/contact-us']">Book a Consultation</button>
      </div>
    </div>
  </section>

  <section class="microdissection_tese mt-5">
    <div class="container">
      <div class="wrapper">
        <h4 class="title_header tac">Microdissection TESE (Micro-TESE)</h4>

        <div class="section">
          <h2>What is Microdissection TESE?</h2>
          <ul>
            <li>
              Micro-TESE is an advanced surgical sperm retrieval technique using
              an operating microscope to identify and extract the healthiest
              sperm-producing areas in the testicles.
            </li>
          </ul>
        </div>

        <div class="section">
          <h2>Ideal for:</h2>
          <ul>
            <li>Men with severe non-obstructive azoospermia</li>
            <li>Prior failed sperm retrieval attempts</li>
          </ul>
        </div>

        <div class="section">
          <h2>Key Benefits of Micro-TESE:</h2>
          <ul>
            <li>Highest success rates in challenging male infertility cases</li>
            <li>Reduced testicular damage due to targeted tissue removal</li>
            <li>Performed by highly experienced fertility microsurgeons</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="why_choose_ncare_ivf_kannur mt-5">
    <div class="container">
      <h4 class="title_header tac">
        Why Choose NCare IVF Kannur, Kerala for Sperm Retrieval?
      </h4>
      <div class="row">
        <span></span>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/sperm_retrieval_techniques/wcsr_1.webp"
              alt=""
            />
            <h5>Expert Andrology Team</h5>
            <p>
              Skilled andrologists with extensive experience in complex sperm
              retrieval procedures.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/sperm_retrieval_techniques/wcsr_2.webp"
              alt=""
            />
            <h5>State-of-the-Art Microscopy</h5>
            <p>High-resolution operating microscopes for precise MicroTESE.</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/sperm_retrieval_techniques/wcsr_3.webp"
              alt=""
            />
            <h5>Personalized Treatment Planning</h5>
            <p>Comprehensive assessment and counseling before procedures.</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/sperm_retrieval_techniques/wcsr_4.webp"
              alt=""
            />
            <h5>Safe & Comfortable Procedures</h5>
            <p>
              All retrievals done under anesthesia with minimal discomfort and
              quick recovery.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/sperm_retrieval_techniques/wcsr_5.webp"
              alt=""
            />
            <h5>Seamless IVF/ICSI Integration</h5>
            <p>
              Sperm retrieval and use in ICSI performed in one continuous,
              well-coordinated cycle.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="what_we_provide mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img
            loading="lazy"
            src="../../assets/images/treatment/what_we_provide.webp"
            alt=""
          />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6>Success Rates of Sperm Retrieval Techniques</h6>
          <ul>
            <li>
              <span>PESA/TESA:</span>– Success rates of 80–100% in obstructive
              azoospermia.
            </li>
            <li>
              <span>TESE:</span> – Approximately 50–60% sperm retrieval success
              in non-obstructive cases.
            </li>
            <li>
              <span>Micro-TESE:</span> – Up to 60% success rate in men with
              severe non-obstructive azoospermia, with higher pregnancy success
              rates due to high-quality sperm selection.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="faq mt-5">
    <h4 class="title_header tac">Frequently Asked Questions</h4>
    <div class="container">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              How long can eggs, sperm, and embryos be stored?
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              They can be stored for 10+ years without loss of quality, as per
              medical guidelines.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Are sperm retrieval procedures painful?
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              No. They are performed under local or short general anesthesia,
              and patients typically experience minimal discomfort.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How long does recovery take?
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Most men can return to normal activities within 1–2 days after
              TESA, PESA, or TESE. MicroTESE may require slightly longer rest.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Can retrieved sperm be frozen for future use?
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Yes, sperm retrieved during these procedures can be cryopreserved
              for future IVF or ICSI cycles.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              Does sperm retrieval guarantee pregnancy?
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Sperm retrieval significantly increases the chances of successful
              fertilization via ICSI. However, success also depends on female
              fertility factors and embryo quality.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              Will there be any long-term side effects?
            </button>
          </h2>
          <div
            id="collapseSix"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              These are minor procedures with very low risk. Rarely, swelling or
              mild discomfort may occur, which resolves quickly.
            </div>
          </div>
        </div>
      </div>
      <button class="contact_us_info" (click)="contactus()">
        Contact Us for more information
      </button>
    </div>
  </section>
</div>
